<template>
  <div
    class="m-dropdown-content m-dropdown-content-left"
    id="MoleculeEditionBillingMyPaymentsDropDownFilters"
  >
    <section
      v-if="showLoadingState < 2"
      key="loadingState"
      class="m-dropdown-section"
    >
      <ul class="m-dropdown-list">
        <li>
          <a
            href="#"
            @click.prevent=""
          >
            <AtomLoadingSecondary/>
          </a>
        </li>
      </ul>
    </section>
    <form
      v-else
      key="billingMyPaymentsDropDownFilters"
      autocomplete="off"
      name="MyPaymentsDropDownFilters"
      spellcheck="false"
      @submit.prevent="searchAdvancedFilter"
    >
      <section class="m-dropdown-section">
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMyPaymentsDropDownFilters.input.estado.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <ul>
                <li
                  v-for="(estado, index) in estadosPagos"
                  :key="index"
                >
                  <AtomCheckboxPrimary
                    v-model="filter.estado"
                    inputStyle="billing"
                    name="estado"
                    :text="estado.name"
                    :value="estado.id"
                    wrapper-class="margin-zero"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMyPaymentsDropDownFilters.input.divisa.label') }}
            </a>
            <div class="m-dropdown-sublist m-dropdown-sublist-scrollable">
              <ul>
                <li
                  v-for="(divisa, index) in divisas"
                  :key="index"
                >
                  <AtomCheckboxPrimary
                    v-model="filter.divisa"
                    inputStyle="billing"
                    name="moneda"
                    :text="divisa.nombre"
                    :value="divisa.id_divisa"
                    wrapper-class="margin-zero"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a href="#">
             {{ $t('mEditionBillingMyPaymentsDropDownFilters.input.medioPago.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <ul>
                <li
                  v-for="(pasarela, index) in pasarelas"
                  :key="index"
                >
                  <AtomCheckboxPrimary
                    v-model="filter.pasarela_pago"
                    inputStyle="billing"
                    name="medio"
                    :text="pasarela.nombre"
                    :value="pasarela.id"
                    wrapper-class="margin-zero"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMyPaymentsDropDownFilters.input.fechaDesde.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomDatePicker
                v-model="filter.fecha_desde"
                label=""
                name="fecha_desde"
                :placeholder="$t('mEditionBillingMyPaymentsDropDownFilters.input.fechaDesde.placeholder')"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMyPaymentsDropDownFilters.input.fechaHasta.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomDatePicker
                v-model="filter.fecha_hasta"
                :disabled-dates="disabledDates"
                name="fecha_hasta"
                :placeholder="$t('mEditionBillingMyPaymentsDropDownFilters.input.fechaHasta.placeholder')"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMyPaymentsDropDownFilters.input.descuento.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <input
                v-model="filter.cupon"
                class="a-input-primary"
                name="descuento"
                :placeholder="$t('mEditionBillingMyPaymentsDropDownFilters.input.descuento.placeholder')"
                type="text"
              >
            </div>
          </li>
        </ul>
      </section>
      <footer class="m-dropdown-footer">
        <button
          class="a-button-dropdown-secondary"
          @click="reloadListing"
        >
         {{ $t('mEditionBillingMyPaymentsDropDownFilters.buttons.btnReiniciarText') }}
        </button>
        <button
          class="a-button-primary a-button-billing-primary a-button-dropdown-primary"
          type="submit"
        >
          {{ $t('mEditionBillingMyPaymentsDropDownFilters.buttons.btnFilterText') }}
        </button>
      </footer>
    </form>
  </div>
</template>
<script>
export default {
  name: 'MoleculeEditionBillingMyPaymentsDropDownFilters',

  props: {
    filterSeted: Object
  },

  data () {
    return {
      disabledDates: {
        to: ''
      },

      divisas: [],
      estadosPagos: [],

      filter: {
        estado: [],
        divisa: [],
        pasarela_pago: [],
        fecha_desde: '',
        fecha_hasta: '',
        cupon: '',
        pagina: 1,
        limite: 10
      },

      pasarelas: [],
      showLoadingState: 0,
      tipoComprobantes: []
    }
  },

  watch: {
    'filter.fecha_desde' () {
      if (this.$moment(this.filter.fecha_desde).isAfter(this.filter.fecha_hasta)) {
        this.filter.fecha_hasta = null
      }

      this.disabledDates = {
        to: this.filter.fecha_desde
      }
    },

    filterSeted: {
      deep: true,

      handler () {
        this.filter.cupon = this.filterSeted.cupon
        this.filter.divisa = [...this.filterSeted.divisa]
        this.filter.estado = [...this.filterSeted.estado]
        this.filter.fecha_desde = this.filterSeted.fecha_desde
        this.filter.fecha_hasta = this.filterSeted.fecha_hasta
        this.filter.pasarela_pago = [...this.filterSeted.pasarela_pago]

        this.disabledDates = {
          to: this.filter.fecha_desde
        }
      },

      immediate: true
    }
  },

  created () {
    this.estadosPagos = [...this.$filters.parameters.paymentsStates]
    this.estadosPagos.shift()
    this.readDivisas()
    this.readPasarelasPagoActivas()
  },

  methods: {
    readDivisas () {
      this.$services.read('divisa', 'readDivisas')
        .then(response => {
          this.divisas = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readPasarelasPagoActivas () {
      this.$services.read('pasarela', 'readPasarelas')
        .then(response => {
          this.pasarelas = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    reloadListing () {
      this.$emit('reloadListing')
    },

    searchAdvancedFilter () {
      this.$dropDown.switchDropDown('MoleculeEditionBillingMyPaymentsDropDownFilters')
      this.$emit('searchAdvancedFilter', this.filter)
    }
  }
}
</script>
